import AbstractWidget from "@/models/WebsiteWidget/AbstractWidget";
import WebsiteWidget from "@/models/WebsiteWidget/WebsiteWidget";

export default class LegalContent extends AbstractWidget {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'website-widget/legal-content';

    /**
     *
     * @type {string}
     */
    static entity = 'websiteWidgetLegalContents';

    static model_name = 'LegalContent';

    static fields() {
		return {
			id: this.attr(null),
			legal_content_id: this.attr(null),
			created_at: this.attr(null),
			updated_at: this.attr(null),
            widget: this.hasOne(WebsiteWidget, 'widgetable_id'),
		}
	}

    /**
     *
     * @returns {*}
     * @constructor
     */
    Widget() {
        return WebsiteWidget.byWidgetable(this.WidgetTemplate().key, this.id);
    }
}
